module.exports = __webpack_public_path__ + "static/img/winners-second.fb55e018.jpg";